export enum AppName {
  FaunaProtect = "FaunaProtect",
  BioEcologie = "BioEcologie",
  EcoAssist = "EcoAssist",
  FaunaBeheer = "FaunaBeheer",
  FaunaViewer = "FaunaViewer",
}

export const WORKER_SCHEDULE = {
  FROM_TIME: "08:00",
  TO_TIME: "17:00",
  WORKER_HOURS: "08:00",
};

export const routes = {
  login: "/login",
  resetpassword: "/resetpassword",
  planning: "/planning",
  task: "/task",
  taskdetail: "/taskdetail",
  updatetaskdetail: "/updatetaskdetail",
};

export const storageKeys = {
  authToken: "authToken",
  workerId: "workerId",
  userId: "userId",
  isAuthenticated: "isAuthenticated",
  projectId: 'projectId',
  projectName: 'projectName',
  emailId: 'emailId',
  userName: "userName",
  selectedProject: "selectedProject",
  timerStartTime: "timerStartTime",
  timerIsRunning: "timerIsRunning",
  selectedProjectForLog: "selectedProjectForLog",
  selectedProjectIdForNavigation: "selectedProjectIdForNavigation",
  lastPopupTime: "lastPopupTime",

};

/* eslint-disable */

export const color = {
  color_app_theme: "#39ac39",
  color_header: "#03030be6",
  color_background: "#FFF",
  color_white: "#FFFFFF",
  color_orange1: "#e94e17",
  color_theme: "#970909",
  color_vividblue: "#33B5E3",
  color_black: "#000000",
  color_grey: "#7C7C7C",
  color_border: "#D8D8D8",
  color_lighttext: "#5E5E5E",
  color_text: "#303030",
  color_orange: "#F0AD4E",
  color_lightGrey: "#f5f5f5",
  color_darkGrey: "#d3d3d3",
  color_lightRed: "#EA3B3B",
  color_viewAll: "#999999",
  color_retailList: "#303030",
  color_star: "#FFE443",
  color_mapborder: "#ADADAD",
  color_yellow: "#FFDF00",
  color_red: "#E60000",
  color_normal_green: "#00CC00",
  color_store_list_row: "#303030",
  color_store_list_separator: "#ADADAD",
  color_store_list_circle: "#5CB85C",
  color_button_border: "#303030",
  color_blue: "#35B5CC",
  color_purple: "#D45190",
  color_green: "#97B812",
  color_darkBlue: "#0056b3",
  color_lightGreen: "#79d2a6",
  color_weekCalendar_Border: "#e6e6e6",
  color_emptyList: "#ecf0f1",
  color_werkuren_button: "#adebad",
  color_werkuren_border: "#bfbfbf",
  // color_planning_over_view_red_card: 'rgb(226, 109, 109)',
  // color_planning_over_view_blue_card: 'rgb(207, 222, 219)',
  color_planning_over_view_red_card: "rgb(200, 93, 83)",
  color_planning_over_view_blue_card: "rgb(146, 201, 239)",
  color_placeholder: "#C8C8C8",
  color_lightWhite: "#F0F0F0",
};
